import { Component, computed, input } from '@angular/core';
import { countryDisplay } from '../../utils/country-flags';

@Component({
  selector: 'app-country-label',
  template: `
    <span class="country-label">
      @if (display().flag) {
        <span class="country-flag" aria-hidden="true">{{ display().flag }}</span>
      }
      <span class="country-name">{{ display().label }}</span>
    </span>
  `,
  styles: `
    .country-label {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      min-width: 0;
    }

    .country-flag {
      flex-shrink: 0;
      font-size: 1.05em;
      line-height: 1;
    }

    .country-name {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `,
})
export class CountryLabelComponent {
  readonly country = input.required<string>();

  readonly display = computed(() => countryDisplay(this.country()));
}
